import countries from './country';
import currencies from './currency';
import languages from './language';

export default {
  methods: {
    getCountries() {
      return Object.keys(countries.country)
        .map(key => ({
          id: key,
          label: countries.country[key],
        }));
    },
    getCurrencies() {
      return currencies.map(currency => ({
        id: currency.Code,
        label: currency.Currency,
      }));
    },
    greaterThanZero(value) {
      return value > 0;
    },
    formatPrice(value) {
      const val = value;
      return val.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getLanguages() {
      return languages;
    },
    padTo2Digits(num) {
      return num.toString()
        .padStart(2, '0');
    },
    secToMinFormat(totalSeconds) {
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${this.padTo2Digits(minutes)}:${this.padTo2Digits(seconds)}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/helpers.mixins.js